/*
 * @Author: chengyu
 * @Date: 2022-09-26 20:14:11
 * @Description: 浏览器jsonp请求 仅支持`GET`请求
 */
// @ts-ignore
import EngineWrapper from 'flyio/dist/npm/engine-wrapper.js';
// @ts-ignore
import _Fly from 'flyio/dist/npm/fly.js';
// @ts-ignore
import adapter from './adapter/jsonp';
var engine = EngineWrapper(adapter);
export default (function () {
    return new _Fly(engine);
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianNvbnAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29yZS9yZXF1ZXN0L2h0dHAvanNvbnAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUdILGFBQWE7QUFDYixPQUFPLGFBQWEsTUFBTSxrQ0FBa0MsQ0FBQztBQUM3RCxhQUFhO0FBQ2IsT0FBTyxJQUFJLE1BQU0sdUJBQXVCLENBQUM7QUFFekMsYUFBYTtBQUNiLE9BQU8sT0FBTyxNQUFNLGlCQUFpQixDQUFDO0FBRXRDLElBQU0sTUFBTSxHQUFHLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUV0QyxnQkFBZTtJQUNiLE9BQU8sSUFBSSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7QUFDMUIsQ0FBQyxFQUFDIn0=